/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {Reducer} from 'redux';

import {IChannel} from 'interfaces/channelProps';
import {
  SET_STREAMING_PROPERTY,
  CHANNEL_DETAILS_FETCHING,
  CHANNEL_DETAILS_FETCHING_DONE,
  CHANNEL_DETAILS_FETCHING_ERROR,
  ChannelsActions
} from 'store/action/channels';
import {IPortalError} from 'utility/error-handler';

export interface IChannelDetailsState {
  channelDetails: IChannel | null;
  isFetching: boolean;
  error: null | IPortalError;
}

const initialChannelDetailsState: IChannelDetailsState = {
  channelDetails: null,
  isFetching: false,
  error: null
};
const channelDetailsReducer: Reducer<Readonly<IChannelDetailsState>, ChannelsActions> = (
  state: IChannelDetailsState = initialChannelDetailsState,
  action: ChannelsActions
) => {
  switch (action.type) {
    case CHANNEL_DETAILS_FETCHING:
      return {
        ...state,
        error: null,
        isFetching: true
      };
    case CHANNEL_DETAILS_FETCHING_ERROR:
      return {
        ...state,
        error: action.error,
        isFetching: false
      };
    case SET_STREAMING_PROPERTY:
      return {
        ...state,
        channelDetails: {
          ...state.channelDetails,
          isStreamingEnabled: action.value
        }
      };
    case CHANNEL_DETAILS_FETCHING_DONE:
      return {
        channelDetails: {
          ...action.payload,
          isStreamingEnabled: false
        },
        error: null,
        isFetching: false
      };
    default:
      return state;
  }
};

export default channelDetailsReducer;